import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';

const SHARED_STACK_STYLES: React.CSSProperties = {
  flex: 1,
  flexDirection: 'row',
  gap: 1,
};

export const StyledLeftAlignedStack = styled(Stack)(() => ({
  justifyContent: 'flex-start',
  ...SHARED_STACK_STYLES,
}));

export const StyledRightAlignedStack = styled(Stack)(() => ({
  justifyContent: 'flex-end',
  ...SHARED_STACK_STYLES,
}));
